require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/fn/object/get-prototype-of.js
// module id = 1989
// module chunks = 2